import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_985aneiq: FaireBrandEntity = {
  token: "b_985aneiq",
  type: "brand",
  name: "Twenty Two West",
  avatarUrl:
    "https://cdn.faire.com/fastly/4bcb6357e375126b9c5b617927a1a0827b50b907677abd7a489ea6bae8006d0e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/599de0590e825b7d9edfcf66baa13ff8a9ce3e9038c1f089d6ef64fdcd7e9dd7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4bcb6357e375126b9c5b617927a1a0827b50b907677abd7a489ea6bae8006d0e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/599de0590e825b7d9edfcf66baa13ff8a9ce3e9038c1f089d6ef64fdcd7e9dd7.jpeg",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 14,
  isTopShop: true,
  isInsider: true,
  description:
    "Twenty Two West comes from a place that inspires me - \n\nIt’s the address of the home where I grew up and discovered the love of creating through the women who loved it before me. \n\nOur lives are often filled with things that are mass-produced. My goal is to be in direct contrast to that by creating artisan jewelry and home décor that inspires an artful life. \n\nThe moment I walk in the studio door I feel a rush of anticipation and excitement to create. I start my day with clay and threads and through the process of forming, firing, combing, and weaving, I get to see the raw materials transform into meaningful treasures. Each is a visual reminder of how perfectly wonderful it is to be artful, strong, and kind.\n\nEthically sourced. Ethically made. \n\nThe happiness that comes from creating is truly unmatched. I hope this little part of our creative days in the studio makes your days and home brighter.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:32.291Z",
    importedBy: "entity-db-cli",
  },
};
